import { type ApiClient, getResponseData } from "@/modules/api/apiClient.ts";
import { urlEncodedBody } from "@/utils/fetchClient.ts";
import type { BucketCorsBody } from "@warrenio/api-spec/spec.oats.gen";

export async function bucketCorsRequest(apiClient: ApiClient, body: BucketCorsBody) {
    return getResponseData(
        await apiClient.PUT("/storage/bucket/cors", {
            ...urlEncodedBody,
            parseAs: "text",
            body,
        }),
    );
}
